import React from 'react';
import { Box } from '@mui/material';
import { useFeatureTheme } from '../../../theme/hooks/useFeatureTheme';

/**
 * Lightweight text tabs for list filters — optional, left-aligned, full-width safe.
 */
export default function TableFilterTabs({
  value,
  onChange,
  items = [],
  ariaLabel = 'Filter tabs',
  sx = {},
}) {
  const { semantic, typography } = useFeatureTheme();

  if (!items.length) {
    return null;
  }

  return (
    <Box
      role="tablist"
      aria-label={ariaLabel}
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 2.5,
        borderBottom: `1px solid ${semantic.borders.border}`,
        ...sx,
      }}
    >
      {items.map((item) => {
        const isActive = value === item.value;
        return (
          <Box
            key={item.value}
            component="button"
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(item.value)}
            sx={{
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              pb: 1.25,
              mb: '-1px',
              color: isActive ? semantic.interactive.primary : semantic.text.secondary,
              fontSize: typography.fontSizeSm,
              fontWeight: isActive ? typography.fontWeightSemibold : typography.fontWeightMedium,
              borderBottom: isActive
                ? `2px solid ${semantic.interactive.primary}`
                : '2px solid transparent',
              transition: 'color 160ms ease, border-color 160ms ease',
              '&:hover': {
                color: semantic.interactive.primary,
              },
              '&:focus-visible': {
                outline: 'none',
                boxShadow: `0 0 0 3px ${semantic.borders.focusRing}`,
                borderRadius: '4px',
              },
            }}
          >
            {item.label}
            {typeof item.badge === 'number' || typeof item.badge === 'string' ? (
              <Box component="span" sx={{ ml: 0.75, opacity: 0.85 }}>
                {item.badge}
              </Box>
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
}
